import { inject, Injectable } from '@angular/core';
import { RemoteConfig } from '@angular/fire/remote-config';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { getValue } from 'firebase/remote-config';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';

@Injectable({
  providedIn: 'root'
})
export class AppInfoService extends BaseInjectorService {

  private remoteConfig = inject(RemoteConfig);

  constructor(
    private appService: AppService
  ) { 
    super();
  }

  async getCurrentAppVersion() {
    const appVersion: string = this.platform.is('mobileweb')
      ? '5.11.11'
      : (await App.getInfo()).version;
    return appVersion;
  }

  async getNewUpdateStatus() {
    let updateAvailable = false;

    // Approach 1
    if (this.appService.connectionState && Capacitor.isNativePlatform()) {
      const appVersion: string = await this.getCurrentAppVersion();

      // await fetchAndActivate(this.remoteConfig);

      const appVersionConfig = getValue(this.remoteConfig, 'appVersionConfig');
      const app_update_config = JSON.parse((appVersionConfig as any)._value);
      // this.lastUpdateTime = new Date(app_update_config.force_update_date);
      // const timeoutInterval = parseInt(app_update_config.pop_up_duration) * 60 * 60 * 1000; // 8 hours in milliseconds

      if (
        parseInt(appVersion.replace(/\./g, '')) <
        parseInt(app_update_config.app_version.replace(/\./g, ''))
      ) {
        updateAvailable = true;

        // if (
        //   Date.now() - this.lastPopUpTime >= timeoutInterval ||
        //   Date.now() >= Date.parse(this.lastUpdateTime.toDateString())
        // ) {
        //   updateAvailable = true;
        // } else {
        //   updateAvailable = false;
        // }
      }
    }

    // Approach 2
    // this.lastPopUpTime = (await this.lhStorage.get('lastPopUpTime')) || 0;
    // updateAvailable = this.lastPopUpTime ? true : false;

   // console.log('getNewUpdateStatus updateAvailable : ', updateAvailable);
    return updateAvailable;
  }
}
